<mojo-list-widget-table tableTitle="" [table]="table" [displayExportButton]="true" [displayEditColumnsButton]="true" (onRowSelect)="onRowSelect($event)">
  <ng-template #rowTemplate let-rowData="rowData" let-columns="columns">
    <td *ngFor="let col of columns" [hidden]="col.isSystemColumn" class="ui-resizable-column">
      <ng-container *ngIf="col.field == 'Status'">
        <div [ngClass]="getCssClassNameFromStatusDescription(rowData[col.field])"></div>
      </ng-container>
      {{formatByColumnType(rowData[col.field], col)}}
    </td>
  </ng-template>
</mojo-list-widget-table>
